'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class evlFieldModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	isInstruction(){
		if(typeof(this.instruction) !== 'undefined' && this.instruction !== ''){
			return true;
		}
		return false;
	}
	
	getInstruction(){
		if(!this.isInstruction()){
			return '';
		}
		return this.s('$filter')('nl2br')(this.instruction);
	}
	
	isVisible(){
		if(typeof(this.hidden) !== 'undefined' && true === this.hidden){
			return false;
		}
		return true;
	}
	
	requireComment(){
		return (this.value === 0 || this.value === '0');
	}
	
}